import { formatDate } from "../../../utils/dateUtils";

export const groupCommentsByDate = (comments) => {
    const groups = {};
    comments?.forEach(comment => {
      const dateStr = formatDate(comment.datePosted);
      if (!groups[dateStr]) {
        groups[dateStr] = [];
      }
      groups[dateStr].push(comment);
    });
    return groups;
  };